import { render, staticRenderFns } from "./CustomerContactPersonViewPopup.vue?vue&type=template&id=bd69f068&"
import script from "./CustomerContactPersonViewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerContactPersonViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports